import * as React from "react";

import {
  CustomerGroupFilterState,
  DashboardFilterState,
  HeatingFilter,
  ProductType,
  Tariff,
  TernaryFilterOption,
} from "../../../types/index";
import { FilterGroup } from "../constants";
import FilterContainer from "../FilterContainer";
import CustomerTariffsFilter from "./CustomerTariffsFilter";
import { ContractExistingOptions } from "./FilterOptions";

interface Props {
  heatingFilter: HeatingFilter;
  superordinateFilter: "CustomerGroupFilter" | "DashboardFilter";
  enabled: boolean;
  changeFilter: (
    payload: Partial<CustomerGroupFilterState> | Partial<DashboardFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, enabled: boolean) => void;
}

class HeatingFilterComponent extends React.Component<Props> {
  private changeHeatingFilter = (
    changedPartsHeatingFilter: Partial<HeatingFilter>
  ) => {
    this.props.changeFilter({
      heatingFilter: {
        ...this.props.heatingFilter,
        ...changedPartsHeatingFilter,
      },
    });
  };

  private changeContractFilter = (filter: TernaryFilterOption) => {
    this.changeHeatingFilter({ contractExistingFilter: filter });
  };

  private changeFilterEnabled = (enabled: boolean) => {
    this.props.handleEnabledChange(FilterGroup.heating, enabled);
  };

  private changeTariffsFilter = (tariffs: Tariff[]) => {
    this.changeHeatingFilter({ tariffs });
  };

  public render(): JSX.Element {
    return (
      <FilterContainer
        title="Fernwärmeverträge"
        enabled={this.props.enabled}
        onEnabledChange={this.changeFilterEnabled}
      >
        {(disabled?: boolean) => (
          <>
            <ContractExistingOptions
              contractExistingFilterState={
                this.props.heatingFilter.contractExistingFilter
              }
              onChange={this.changeContractFilter}
              disabled={disabled}
            />
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <CustomerTariffsFilter
                productTypeFilter={this.props.heatingFilter}
                onChange={this.changeTariffsFilter}
                productType={ProductType.HEATING}
                disabled={disabled}
              />
            )}
          </>
        )}
      </FilterContainer>
    );
  }
}

export default HeatingFilterComponent;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/HeatingFilter.tsx